<template>
    <v-app id="keep">
        <!-- left drawer -->
        <v-navigation-drawer
            v-model="settingsDrawer"
            class="grey lighten-4"
            fixed clipped app>
            <v-expansion-panel>
                <v-expansion-panel-content><!-- traditionnel -->
                    <div slot="header" class="headline">Traditionnel</div>
                    <v-card>
                        <v-card-text>
                        <v-select
                            v-model="bases.now.record"
                            @change="activateBase" 
                            label="Rythme"
                            :items="bases.records"
                            item-text="name"
                            item-value="id"
                        ></v-select>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>
                <v-expansion-panel-content><!-- composition libre -->
                    <div slot="header" class="headline">Composition libre</div>
                    <v-card><!-- instrument -->
                        <v-card-text>
                            <v-select 
                                v-model="bases.now.instrument"
                                @change="changeBasesPlaySettings"
                                label="Instrument"
                                :items="Object.values(instruments).sort( (a,b) => { return (a.name<b.name)?-1:1; } )"
                                item-text="name"
                                item-value="id"
                            ></v-select>
                        </v-card-text>
                    </v-card>
                    <v-card><!-- tempo (signature rythmique -->
                        <v-card-text>
                            <v-select 
                                v-model="bases.now.tempo" 
                                @change="changeBasesPlaySettings"
                                label="Tempo"
                                :items="Object.values(tempos)"
                                item-text="name"
                                item-value="id"
                            ></v-select>
                        </v-card-text>
                    </v-card>
                    <!-- 
                    <v-card>
                        <v-card-text>
                            <v-select :items="appels" v-model="music.callName" label="Choisis un appel" item-text="label" item-value="key" solo ></v-select>
                        </v-card-text>
                    </v-card>
                    -->
                    <v-card>
                        <v-card-text>
                            <v-btn @click="cleanAllBasesHits" :disabled="!bases.now.instrument" title="Effacer toute la programmation courante." color="error">Effacer toutes les notes</v-btn>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-navigation-drawer>
        <!-- "play" drawer -->
        <v-navigation-drawer fixed v-model="playDrawer" right clipped app >
            <v-expansion-panel class="px-2">
                <v-expansion-panel-content><!-- bpm -->
                    <div slot="header" class="subheading font-weight-medium">Vitesse: <span class="primary--text">{{ music.bpm }} BPM</span></div>
                    <v-card>
                        <v-slider
                            v-model="music.bpm"
                            :thumb-size="24" thumb-color="#1565C0"
                            :min="40" :max="200" :step="5"
                            thumb-label="always"
                            ></v-slider>
                    </v-card>
                    <!-- feature request: augmenter progressivement la vitesse -->
                </v-expansion-panel-content>
                <v-expansion-panel-content><!-- séquence -->
                    <div slot="header" class="subheading font-weight-medium">Séquence</div>
                    <v-card>
                        <v-checkbox :label="'Afficher un compte à rebours avant de jouer'" v-model="music.initialCountdown.required"></v-checkbox>
                        <!--
                        <v-checkbox :label="'Commencer par un appel'"  v-model="music.initialCall"></v-checkbox>
                        <v-tooltip left>
                            <span slot="activator">
                                <v-text-field
                                    v-model="music.nbrOfMeasuresBeforeBreak"
                                    label="Nombre de mesures avant chaque break"
                                    hint="Jouer un break toutes les 'x' mesures (0=pas de break)."
                                ></v-text-field>
                            </span>
                            <span>Les 'breaks' sont introduits automatiquement pour indiquer<br />un changement de rythme ou démarrer un solo.</span>
                        </v-tooltip>
                        <v-checkbox v-show="music.playRepeat>0" :label="'Terminer par un appel'" v-model="music.finalCall"></v-checkbox>
                        -->
                        <span class="subheading font-weight-medium">Répéter le rythme combien de fois</span>
                        <div class="text-xs-center">
                            <v-btn-toggle v-model="music.playRepeat">
                                <v-btn :value="1"  flat @click.stop="music.playRepeat=1" ><span class="subheading">1</span></v-btn>
                                <v-btn :value="2"  flat @click.stop="music.playRepeat=2" ><span class="subheading">2</span></v-btn>
                                <v-btn :value="4"  flat @click.stop="music.playRepeat=4" ><span class="subheading">4</span></v-btn>
                                <v-btn :value="8"  flat @click.stop="music.playRepeat=8" ><span class="subheading">8</span></v-btn>
                                <v-btn :value="16" flat @click.stop="music.playRepeat=16"><span class="subheading">16</span></v-btn>
                                <v-btn :value="0"  flat @click.stop="music.playRepeat=0" ><v-icon>all_inclusive</v-icon></v-btn>
                            </v-btn-toggle>
                        </div>
                        <v-tooltip left>
                            <span slot="activator">
                                <v-text-field
                                    v-model="music.muteIterations"
                                    label="Itérations muettes"
                                    hint="Séparer les itérations muettes par des virgules. Ex:2,3,7,9"
                                ></v-text-field>
                            </span>
                            <span>Les itérations muettes sont jouées, mais ne sont pas audibles.<br />Elles servent à s'entrainer à respecter la vitesse et mémoriser la séquence.</span>
                        </v-tooltip>
                    </v-card>
                </v-expansion-panel-content>
                <v-expansion-panel-content><!-- metronome -->
                    <div slot="header" class="subheading font-weight-medium">Métronome</div>
                    <v-card>
                        Jouer les temps au métronome:
                        <v-select :items="metronome.ticks" item-text="label" item-value="key" solo v-model="metronome.tempo"></v-select>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-divider dark class=""></v-divider>
            <v-card class="px-2 text-xs-center">
                <!-- reset current beat to 0 -->
                <v-btn fab color="primary" small
                    @click="setBasesCurrentBeat(0)" title="Reprendre la programmation courante au début.">
                    <v-icon>fast_rewind</v-icon>
                </v-btn>
                <!-- PLAY -->
                <v-btn fab small :disabled="!bases.now.instrument || music.playingMode=='playing'" color="primary" 
                    title="Démarrer la programmation courante."
                    @click.stop="startPlaying">
                    <v-icon>play_arrow</v-icon>
                </v-btn>
                <!-- PAUSE -->
                <v-btn fab color="primary" small :disabled="music.playingMode!='playing'"
                    title="Mettre la programmation courante en pause."
                    @click.stop="pausePlaying">
                    <v-icon>pause</v-icon>
                </v-btn>
                <!-- STOP -->
                <v-btn fab color="primary" small :disabled="music.playingMode=='stopped'"
                    title="Arrêter le programmation courrante."
                    @click.stop="stopPlaying">
                    <v-icon>stop</v-icon>
                </v-btn>
            </v-card>
            <v-card class="px-2 text-xs-center">
                {{ music.loopId }}
            </v-card>
            <v-divider dark class=""></v-divider>
        </v-navigation-drawer>
        <!-- toolbar -->
        <v-toolbar color="orange darken-2" class="white--text" dark app fixed clipped-left clipped-right>
            <v-toolbar-side-icon @click="settingsDrawer = !settingsDrawer"><v-icon>settings</v-icon></v-toolbar-side-icon>
            <span class="title ml-3 mr-5"><span class="font-weight-light">my </span>PERCU<span class="font-weight-light">coach</span></span>
            <v-spacer></v-spacer>
            <v-btn icon @click.stop="playDrawer = !playDrawer">
                <v-icon>play_arrow</v-icon>
            </v-btn>
        </v-toolbar>
        <!-- main content -->
        <v-content>
            <v-container fluid align-start class="grey lighten-4">
                <table style="width:100%">
                    <tbody>
                        <tr><!-- running beat -->
                            <td></td>
                            <template v-for="(beats, mindex) in tempos[bases.now.tempo].beats">
                                <td style="width:1em; height:1em;"></td><!-- separateur de temps -->
                                <td 
                                    v-for="(notes, bindex) in tempos[bases.now.tempo].notes" :key="'repere_de_note_'+mindex+'_'+bindex"
                                    style="border:1px solid black; border-radius:6px; cursor:pointer;" 
                                    :style="{ background:(bases.now.currentBeat==bindex+mindex*(tempos[bases.now.tempo].notes)) ? '#07f' : 'inherit' }"
                                    @click="setBasesCurrentBeat(bindex+mindex*(tempos[bases.now.tempo].notes))"
                                    :title="'Positionne le métronome au beat '+bindex+'/'+mindex"></td>
                            </template>
                        </tr>
                        <!-- instrument sounds -->
                        <template v-if="bases.now.instrument">
                            <tr v-for="(sound, soundIndex) in instruments[bases.now.instrument].sounds" :key="'soundindex_'+soundIndex">
                                <!-- controls -->
                                <td style="width:10em; white-space:nowrap;">
                                    <div class="text-xs-center">
                                        <v-speed-dial
                                            right="true"
                                            direction="right"
                                            open-on-hover="true"
                                            transition="scale-transition"
                                            >
                                            <v-btn slot="activator" v-model="fab" :color="(bases.now.sounds[soundIndex].mute ?'error':'primary')" dark>
                                                <v-tooltip top>
                                                    <template slot="activator">
                                                        <v-progress-circular
                                                            :rotate="-90"
                                                            :size="20"
                                                            :width="4"
                                                            :value="bases.now.sounds[soundIndex].volume * 10"
                                                            color="white"
                                                            style="cursor:pointer;"
                                                            @mousewheel.prevent="wheeling($event, bases.now.sounds[soundIndex])"
                                                            >
                                                        </v-progress-circular>
                                                        {{ bases.now.sounds[soundIndex].volume }}
                                                    </template>
                                                    <span>Controle du volume de cette ligne: utiliser la roulette de la souris pour augmenter ou diminuer.</span>
                                                </v-tooltip>
                                                -
                                                {{ sound.name }}
                                            </v-btn>
                                            <v-btn fab dark small color="blue" @click="play(soundIndex)"><v-icon>music_note</v-icon></v-btn>
                                            <v-btn fab dark small color="green"  @click="bases.now.sounds[soundIndex].mute=!bases.now.sounds[soundIndex].mute"><v-icon>volume_off</v-icon></v-btn>
                                            <v-btn fab dark small color="red" @click="emptyThisBaseLine(soundIndex)"><v-icon>delete</v-icon></v-btn>
                                        </v-speed-dial>
                                        <!-- reglage du volume -->
                                        <!-- v-tooltip right>
                                            <template slot="activator">
                                                <v-progress-circular
                                                    :rotate="-90"
                                                    :size="20"
                                                    :width="4"
                                                    :value="bases.now.sounds[soundIndex].volume * 10"
                                                    color="primary"
                                                    style="cursor:pointer;"
                                                    @mousewheel.prevent="wheeling($event, bases.now.sounds[soundIndex])"
                                                    >
                                                </v-progress-circular>
                                                {{ bases.now.sounds[soundIndex].volume }}
                                            </template>
                                            <span>Controle du volume de cette ligne: utiliser la roulette de la souris pour augmenter ou diminuer.</span>
                                        </v-tooltip -->
                                    </div>                                
                                </td>
                                <!-- the sounds to play -->
                                <template v-for="(beats, mindex) in tempos[bases.now.tempo].beats">
                                    <td style="width:1em;"></td><!-- separateur de temps -->
                                    <td 
                                        v-for="(notes, bindex) in tempos[bases.now.tempo].notes" :key="'note_courante_'+mindex+'_'+bindex"
                                        :class="getHitClasses(bindex+mindex*(tempos[bases.now.tempo].notes))"
                                        @click="setHit(soundIndex, mindex, bindex)"
                                        style=""
                                        :style="{ background:(bases.now.sounds[soundIndex].hits[bindex+mindex*(tempos[bases.now.tempo].notes)]==1)?'#07f':'inherit' }"
                                        ></td>
                                </template>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </v-container>
            <!-- panneau du compte à rebours -->
            <v-container v-if="music.initialCountdown.active" fill-height fluid style="z-index:100; background-color:#fffd; position:absolute; top:0; left:0;">
                <v-layout justify-center align-center>
                    <v-flex shrink>
                        <v-progress-circular
                            id="progress_circle"
                            :size="200"
                            :width="40"
                            :rotate="-90"
                            color="#07f"
                            :value="music.initialCountdown.currentValue"
                        >
                            <div class="display-4 font-weight-bold" style="text-align:center; color:#07f;">{{ 5 - music.initialCountdown.currentCount }}</div>
                        </v-progress-circular>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
        <!-- footer -->
        <v-footer color="orange darken-2" class="white--text" app>
            <span class="ml-3">PERCUcoach</span>
            <v-spacer></v-spacer>
            <span class="mr-3">&copy; 2019</span>
        </v-footer>
    </v-app>
</template>

<script>
export default {
    data: () => ({
        playDrawer: false,
        settingsDrawer: true,
        loaded: false,
        metronome: {
            ticks: [ // définit les cooup de métronome
                { label:"aucun"                , key:"none" },
                { label:"tous"                 , key:"all" },
                { label:"uniquement le premier", key:"first" },
                { label:"uniquement le dernier", key:"last" },
            ],
            tempo: 'none', // 'none' | 'first' | 'last' | 'all'
            soundFile: "./sounds/metronome_2.wav",
        },
        music: {
            tempoKey         : "4/4",
            instrument       : null,
            playingMode      : 'stopped',
            playRepeat       : 0,
            muteIterations   : "",
            nbrOfMeasuresBeforeBreak: 0,
            loopId           : 0,           // compteur de boucles
            instruments      : [],
            bpm              : 100,
            initialCountdown : {
                active      : false,
                required    : true,
                currentCount: 0,
                currentValue: 0,
            },
            initialCall      : false,
            intermediateCalls: 0,
            finalCall        : false,
            callName         : null,
        },
        bases: {
            now: {
                record: null,
                tempo: "44",
                instrument: null,
                currentBeat: 0,
                sounds: [],
            },
            records: [],
        },
        tempos: {},
        instruments: {},
        songs: [],
        compos: {},
        appels: [
            { label:"Appel binaire", key:"appel_binaire_1"},
            { label:"Appel ternaire", key:"appel_ternaire_1"}
        ],
    }),
    computed: {
        tickLength: function(){
            return 60000/(this.music.bpm * this.tempos[this.bases.now.tempo].notes);
        },
        muteIterationsList: function(){
            let list = [];
            this.music.muteIterations.split(',').forEach( function(iter){
                console.log("iter", iter);
                if (!isNaN(iter)){
                    list.push(parseInt(iter));
                }
            });
            return list.filter((iter, idx) => { return list.indexOf(iter)==idx; }).sort((a,b) => { return a-b; });
        },
    },
    methods: {
        setBasesCurrentBeat: function(idx){
            this.bases.now.currentBeat = idx;
        },
        changeBasesPlaySettings: function(){ // recreate this.bases.now.sounds
            var self = this;
            self.bases.now.sounds = []; // erase everything first
            var hitNbr = self.tempos[self.bases.now.tempo].notes * self.tempos[self.bases.now.tempo].beats;
            self.instruments[self.bases.now.instrument].sounds.forEach(
                function(sound, sid){
                    // create a sound object
                    self.bases.now.sounds.push(
                        {
                            sound_id: sound.sound_id,
                            howl: new Howl({
                                src: [sound.soundFile],
                                preload: true
                            }),
                            hits:new Array(hitNbr+1).join('0').split('').map(parseFloat),
                            mute:false, 
                            volume:10,
                        }
                    );
                }
            );
        },
        activateBase: function(){
            var self = this;
            // var idx = this.bases.now.record;
            var idx = null;
            var cnt = 0;
            while(cnt<this.bases.records.length){
                if (this.bases.records[cnt].name == this.bases.now.record){
                    idx = cnt;
                    cnt = this.bases.records.length;
                }
                else{
                    cnt++;
                }
            }
            var record = this.bases.records[idx];
            // this.$set(this.bases.now, 'record', idx);
            this.$set(this.bases.now, 'tempo', this.bases.records[idx].tempo);
            this.$set(this.bases.now, 'currentBeat', 0);
            this.$set(this.music, 'bpm', this.bases.records[idx].bpm);
            // CAUTION: first set the value with assignment, so that the update is NOT recognized by Vue
            this.bases.now.instrument = this.bases.records[idx].instrument;
            // create sounds bases on this.bases.now.instrument
            this.changeBasesPlaySettings();
            // tell Vue something has changed (if I do it before, Vue crashes because there's no sound yet!
            // now set the hits
            for (var j=0; j<this.bases.now.sounds.length; j++){
                var sound_id = this.bases.now.sounds[j].sound_id;
                this.$set(this.bases.now.sounds[j], 'volume', record[sound_id].volume);
                this.$set(this.bases.now.sounds[j], 'hits', record[sound_id].hits);
                }
            this.$set(this.bases.now, 'instrument', this.bases.records[idx].instrument);
        },
        getHitClasses: function(hitnb){
            var self = this;
            var res = 'hit';
            // :class="{ currentHit:(bases.now.currentBeat==bindex+mindex*(tempos[bases.now.tempo].notes)) }"
            if (hitnb == self.bases.now.currentBeat){
                res += ' current-hit';
            }
            return res;
        },
        setHit: function(soundIndex, mindex, bindex){
            var self = this;
            var notes = self.tempos[self.bases.now.tempo].notes;
            var hitId = bindex + (mindex * notes);
            var curval = self.bases.now.sounds[soundIndex].hits[hitId];
            self.$set(self.bases.now.sounds[soundIndex].hits, hitId, (curval==0) ? 1 : 0);
        },
        cleanAllBasesHits: function(){
            var self = this;
            var hitNbr = self.tempos[self.bases.now.tempo].notes * self.tempos[self.bases.now.tempo].beats;
            for (var idx=0; idx<self.bases.now.sounds.length; idx++){
                self.emptyThisBaseLine(idx);
            }
        },
        setBasesLineVolume: function(soundIndex, val){
            var vol = this.bases.now.sounds[soundIndex].volume + val;
            if (vol < 0){
                vol = 0;
            }
            if (vol > 10){
                vol = 10;
            }
            this.$set(this.bases.now.sounds[soundIndex], 'volume', vol);
            this.bases.now.sounds[soundIndex].howl.volume(vol/10);
        },
        emptyThisBaseLine: function(idx){
            var self = this;
            var hitNbr = self.tempos[self.bases.now.tempo].notes * self.tempos[self.bases.now.tempo].beats;
            self.$set(self.bases.now.sounds[idx], 'hits', new Array(hitNbr+1).join('0').split('').map(parseFloat));
        },
        getRandomInt: function(max) {
            return Math.floor(Math.random() * Math.floor(max));
        },
        baseLaunch: function(){
            // this.bases.now.playing = true;
            this.music.playingMode = 'playing';
            this.music.loopId = 1;
            this.cycleControl();
        },
        cycleControl: function(){
            var self = this;
            if (self.music.playingMode == 'playing'){
                // controle du métronome
                if (self.metronome.tempo != 'none'){
                    var cetemps = self.bases.now.currentBeat / self.tempos[self.bases.now.tempo].notes;
                    if (/* all */ (cetemps == Math.floor(cetemps) && self.metronome.tempo == "all")
                        || /* first */ (cetemps == 0 && self.metronome.tempo == 'first')
                        || /* last */ (cetemps == self.tempos[self.bases.now.tempo].beats - 1 && self.metronome.tempo == 'last') 
                    ){
                        self.metronome.howl.play()
                    }
                }
                // console.log("tick", self.bases.now.currentBeat);
                if (self.muteIterationsList.indexOf(self.music.loopId) == -1){ // this is the place to mute the requested loops
                    self.bases.now.sounds.forEach(
                        function(sound, idx){
                            if (!sound.mute && sound.hits[self.bases.now.currentBeat]){
                                self.bases.now.sounds[idx].howl.play();
                            }
                        }
                    );
                }
                self.bases.now.currentBeat = (self.bases.now.currentBeat+1) % (self.tempos[self.bases.now.tempo].notes * self.tempos[self.bases.now.tempo].beats);
                if (self.bases.now.currentBeat == 0){
                    if (self.music.playRepeat != 0 && self.music.loopId >= self.music.playRepeat){
                        self.stopPlaying();
                    }
                    self.music.loopId++;
                }
                self.$forceUpdate();
                // console.log("self.tickLength", self.tickLength);
                setTimeout(function(){ self.cycleControl(); }, self.tickLength);
            }
        },
        play: function(idx){
            // required to play the sound sample on the front page
            this.bases.now.sounds[idx].howl.play();
        },
        wheeling: (evt, sound) => {
            console.log("evt", evt, sound);
            if (evt.deltaY < 0  && sound.volume>1){
                sound.volume--;
                console.log("decreasing volume", sound.volume);
            }
            if (evt.deltaY > 0  && sound.volume<10){
                sound.volume++;
                console.log("increasing volume", sound.volume);
            }
        },
        initialiseCountdown: function(){
            let self = this;
            let cd = self.music.initialCountdown;
            let bps = self.music.bpm / 60;
            if (cd.required){
                self.$set(cd, 'active', true);
                self.$set(cd, 'currentCount', 0);
                self.$set(cd, 'currentValue', 0);
                self.metronome.howl.play();
            }
            else{
                self.$set(cd, 'currentCount', 10);
            }
            self.countdown(bps);
        },
        countdown: function(bps){
            let self = this;
            let cd = self.music.initialCountdown;
            if (cd.currentCount < 4){
                if (cd.currentValue < 100){
                    self.$set(self.music.initialCountdown, 'currentValue', cd.currentValue + 5);
                }
                else{
                    self.$set(cd, 'currentValue', 0);
                    self.metronome.howl.play();
                    self.$set(cd, 'currentCount', cd.currentCount + 1);
                }
                setTimeout(function(){ self.countdown(bps); }, 1000 / (bps * 20));
            }
            else {  // end of the countdown
                self.$set(cd, 'active', false);
                self.baseLaunch();
            }
        },
        startPlaying: function(){
            if (this.music.playingMode == 'stopped'){
                this.initialiseCountdown();
            }
            if (this.music.playingMode == 'paused'){
                this.music.playingMode = 'playing';
                this.cycleControl();
            }
        },
        pausePlaying: function(){
            this.music.playingMode = 'paused';
        },
        stopPlaying: function(){
            let self = this;
            // stop the countdown, if active
            self.music.initialCountdown.active = false;
            self.music.playingMode = 'stopped';
            self.setBasesCurrentBeat(0);
        },
    },
    created: function(){
        var self = this;
        // load the metronome sound
        self.metronome.howl = new Howl({
            src: [this.metronome.soundFile],
            preload: true
        });
        var songs = fetch("./songs.json")
            .then( (response) => {
                // console.log("response.text()", response.text());
                return response.json();
            })
            .then( 
            (resp) => {
                // console.log("resp", resp);
                self.$set(self.$data, 'songs', resp);
                // for each object in resp, load the json file
                var promises = [];
                resp.forEach(function(obj){
                    promises.push(fetch('./percucoach/' + obj.file).then( (response) => { return response.json(); } ));
                });
                Promise.all(promises).then(
                    function(vals){
                        self.bases.records = [];
                        vals.forEach(function(val){
                            self.bases.records.push(val);
                        });
                        self.$forceUpdate();
                    }
                );
            },
            (err) => {
                console.log("ERROR", err);
            }
        );
        var temposP = fetch("./tempos.json").then((response) => { return response.json(); });
        var instrumentsP = fetch("./instruments.json").then((response) => { return response.json(); });
        // var recordsP = fetch("../records.json").then((response) => { return response.json(); });
        // Promise.all([ temposP, instrumentsP, recordsP ]).then(
        Promise.all([ temposP, instrumentsP ]).then(
            function(values){
                // console.log("values", values);
                self.tempos = values[0].tempos;
                self.instruments = values[1].instruments;
                // self.bases.records = values[2].records;
                self.loaded = true;
            },
            function(err){
                console.log("An error occurred:", err);
            }
        );
    },
}
</script>

<style lang="less">
#keep {
    .v-navigation-drawer__border {
        display: none;
    }
}
.hit {
    border:1px solid black;
    border-radius:6px;
    box-sizing:border-box;
    min-width:1em;
}
.current-hit {
    border: 2px solid red;
}
.v-input__slot {
    margin-top:0;
    margin-bottom:0;
}
#progress_circle  svg circle.v-progress-circular__overlay {
    -webkit-transition: 0s;
    transition: 0s;
}
</style>
